"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageExtensionToJSON = exports.ImageExtensionFromJSONTyped = exports.ImageExtensionFromJSON = exports.ImageExtension = void 0;
/**
 *
 * @export
 */
exports.ImageExtension = {
    Psd: 0,
    Svg: 1,
    Png: 2,
    Jpg: 3,
    Webp: 4,
    Jpeg: 5
};
function ImageExtensionFromJSON(json) {
    return ImageExtensionFromJSONTyped(json, false);
}
exports.ImageExtensionFromJSON = ImageExtensionFromJSON;
function ImageExtensionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ImageExtensionFromJSONTyped = ImageExtensionFromJSONTyped;
function ImageExtensionToJSON(value) {
    return value;
}
exports.ImageExtensionToJSON = ImageExtensionToJSON;
